import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { renderField, renderSelect, renderRadio, validate } from '../../helpers/validation.helper';
import { connect } from 'react-redux';
import moment from 'moment';
import {withRouter} from "react-router";

class ReservationStep3Form extends Component {
    
    render(){
        const { handleSubmit, getDropdownValues, getMonths, errors} = this.props;
        return (
            <div>
                
                <div className="edit-user-details-page">
                    <div className="row">
                        <div className="col-lg-12">
                                <div className="col-lg-12">
                                
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                        <div className="col-lg-12">
                                            <legend>Completeaza datele pentru facturare</legend>
                                        </div>   
                                        <div className="error-handle">
                                            {errors.error}
                                        </div>
                                        <div className="col-lg-12">
                                            <Field
                                                id="lastName"
                                                name="last_name"
                                                type="text"
                                                placeholder="Nume"
                                                component={renderField}
                                            />
                                        </div>         
                                        <div className="col-lg-12">
                                            <Field
                                                id="firstName"
                                                name="first_name"
                                                type="text"
                                                placeholder="Prenume"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <Field
                                                id="email"
                                                name="email"
                                                type="text"
                                                placeholder="Email"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <Field
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder="Telefon"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <Field
                                                id="address"
                                                name="address"
                                                type="text"
                                                placeholder="Adresa"
                                                component={renderField}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <button className="next-step" type="submit">Plăteşte</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    initialValues: {
        ...state.profile.userDetails,
    },
    errors: state.user.errors
})

const form = reduxForm({
    form: 'paymentForm', // a unique identifier for this form,
    validate: validate('paymentForm'),
    enableReinitialize: true
})

export default withRouter(connect(mapStateToProps,{})(form(ReservationStep3Form)));
    



// WEBPACK FOOTER //
// ./src/SHARED/components/modalreservation/reservationstep3Form.component.js